"use client";

import React, { useState, useEffect } from "react";
import "../../Home.css";

// Self-hosted 80x80 WebP copies of the pravatar.cc placeholders (~1.3 KB each,
// no third-party connection, no extra hero-time preloads).
const randomAvatars = [
  "/images/avatars/11.webp",
  "/images/avatars/12.webp",
  "/images/avatars/13.webp",
  "/images/avatars/14.webp",
  "/images/avatars/15.webp",
  "/images/avatars/16.webp",
];

export default function CustomSurplusAvatars() {
  // Deterministic on first render (server + client's initial hydration
  // pass both render the same first-5) so Math.random() never causes a
  // hydration mismatch; the real shuffle happens client-side right after
  // mount, matching the CRA original's "shuffle once" behavior just
  // deferred by one effect tick.
  const [shuffled, setShuffled] = useState(() => randomAvatars.slice(0, 5));

  useEffect(() => {
    setShuffled([...randomAvatars].sort(() => 0.5 - Math.random()).slice(0, 5));
  }, []);

  return (
    <div className="avatar-group">
      {shuffled.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Learner avatar ${index + 1}`}
          className="avatar-img"
          width={80}
          height={80}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
      ))}

      <div className="avatar-number">+25k</div>
    </div>
  );
}
